export default __webpack_public_path__ + "static/media/brac2.c6082807.jpg";